module.exports = __webpack_public_path__ + "static/img/weis.579c7add.png";